import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_UPDATE_MASTER_PRODUCT } from "../../store/product/productActionTypes";
import { useProductsMaster } from "../../store/product/reducer";
interface Props {
  product: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const ProductDeactiveConfirmation: React.FC<Props> = ({
  product,
  isOpen,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { masterProducts, busy, message } = useProductsMaster()

  const { _id, active } = product;

  useEffect(() => {
    const findLink = masterProducts.find((val: Record<string, any>) => val._id === _id);
    if (findLink.active !== active) {
      onClose();
    }
  }, [_id, masterProducts, onClose, active]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Link</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {product.active
              ? "You are going to Hide this Product? "
              : "You are going to Show this Product? "}
            {product.title}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              const data = { _id: product._id, payload: { active: !product.active } }
              dispatch({
                type: REQUEST_UPDATE_MASTER_PRODUCT,
                data,
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
export default ProductDeactiveConfirmation;
